import React, { Component, useState, useEffect } from "react";
import Footer from "../layouts/Footer";
import Navbar from "../layouts/Navbar";
import { WebLink, SiteWide } from "../customComponents";
import FullScreenInputHolder from "../customComponents/FullScreenInputHolder";

import NoData from "../customComponents/NoData";

import Section from "../layouts/Section";
import { useNavigate, useLocation } from 'react-router-dom';

import Slider from "react-slick";
import { Images } from "../customComponents";
import Colors from '../../utility/Colors';
import Helper1, { notify, styles, money, decimalCount, moneyStatus } from '../../utility/Helper1';

import { depositActions } from '../../redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { allDepositSelect, userSelect, allRemoteSettingsSelect, homeScreenStatSelect } from '../../redux/selectors/index';

import LoadingOverlay from 'react-loading-overlay';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { mainStyle, mainColor, header, footer, otherColors } from '../../utility/styles';

import {
    AiOutlineWallet,
    AiFillCloseCircle,
    AiOutlineCopy,
    AiOutlineCloudUpload,
    AiOutlineDown,
    AiOutlineGlobal
} from "react-icons/ai";
import { RiCurrencyLine, RiArrowDownSLine } from "react-icons/ri";
import CustomAgo from "../customComponents/CustomAgo";
import Countdown from 'react-countdown';



function DepositHistory() {

    const userData = useSelector(userSelect);
    const site_settings = useSelector(allRemoteSettingsSelect);
    const [loadingText, setLoadingText] = useState('Loading history...');

    const [loading, setloading] = useState(false);

    const finance = useSelector(homeScreenStatSelect);
    const [currencySelected, setCurrencySelected] = useState(finance?.[0]);
    const [showCurrencySelector, setShowCurrencySelector] = useState(false);

    const allDepositData = useSelector(allDepositSelect);

    const [amount, setAmount] = useState('');


    const dispatch = useDispatch();


    const uploadPayment = React.useRef(null);

    const progClickPaymentUpload = () => {
        uploadPayment.current.click();
    }



    // Update currency when finance data loads
    useEffect(() => {
        if (finance && finance.length > 0 && !currencySelected) {
            setCurrencySelected(finance[0]);
        }
    }, [finance, currencySelected])

    // Close currency selector when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showCurrencySelector && !event.target.closest('.currency-selector-container')) {
                setShowCurrencySelector(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showCurrencySelector])


    const uploadSelectedPayment = (file) => {

        setLoadingText('Uploading payment...')
        setloading(true)

        dispatch(depositActions.onCreateDeposit({ txn_id: getPendingPayment?.[0]?.txn_id, image: file }, "deposit/manual-deposit-upload", response => {
            setloading(false)
            notify(response.msg, response.code)
        }))

    }




    const getPendingPayment = allDepositData?.filter((item, index) => Number(item.status) < 2);
    const processDeposit = (e) => {

        e.preventDefault();

        if ((isNaN(amount)) || (amount == 0)) {
            notify('Enter amount', 0);
            return false;
        }

        setloading(true)

        setLoadingText('Processing request...')

        dispatch(depositActions.onCreateDeposit({ amount, currency: currencySelected.type }, "deposit/new", response => {
            if (response.code == 1) {
                setAmount('')
            } else {
                notify(response.msg, response.code)
            }

            setloading(false)

        }))
    }







    const deleteInv = (txn_id) => {

        if (getPendingPayment?.[0]?.status != 0) {
            notify('Cannot be deleted as payment is being processed.', 0)
            return;
        }

        setloading(true)
        setLoadingText('Deleting request...')

        dispatch(depositActions.onLoadAllDeposits(`deposit/delete/${txn_id}`, response => {
            if (response.code == 1) {
                // setWhichModal(1)
                // setOpenModal(true)
            }
            setloading(false)
        }))

    }


    const thePendingPayment = () => {

        // let displayableAmount = getPendingPayment?.[0]?.useCryptoValue == 1 ? `${getPendingPayment?.[0]?.amountEnforcedToPay} ${getPendingPayment?.[0]?.abbr}` : `${getPendingPayment?.[0]?.amountEnforcedToPay} USD`
        let displayableAmount = `${getPendingPayment?.[0]?.amountEnforcedToPay} ${getPendingPayment?.[0]?.abbr}`
        let curDetails = finance?.filter((filitem, index) => filitem.type == getPendingPayment?.[0]?.currency)
        let perfectWalletobj;
        let eachParam;


        if ((getPendingPayment?.[0]?.createdWithAutoOrManual == 0) && (getPendingPayment?.[0]?.autoConfirm == 2)) {
            let pmAddress = JSON.parse(getPendingPayment?.[0]?.address);
            eachParam = Object.keys(pmAddress.param);
            perfectWalletobj = pmAddress
        }


        const statusConfig = {
            0: { label: 'Pending', icon: AiOutlineWallet, color: 'text-yellow-400', bgColor: 'bg-yellow-500/20', borderColor: 'border-yellow-400/30' },
            1: { label: 'Processing', icon: AiOutlineCloudUpload, color: 'text-blue-400', bgColor: 'bg-blue-500/20', borderColor: 'border-blue-400/30' }
        };
        const currentStatus = statusConfig[getPendingPayment?.[0]?.status] || statusConfig[0];

        return (
            <div className="min-h-screen p-4">
                <div className="max-w-4xl mx-auto pt-8">
                    {/* Modern Header */}
                    <div className="text-center mb-12">
                        <h1 className="text-4xl font-bold text-white mb-4 bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
                            Pending Payment
                        </h1>
                        <p className="text-xl text-blue-200">
                            Complete your payment to continue
                        </p>
                    </div>

                    {/* Main Payment Card */}
                    <div className="group relative backdrop-blur-xl bg-white/10 rounded-3xl border border-white/20 p-8 shadow-2xl overflow-hidden">
                        {/* Decorative gradient overlay */}
                        <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/5 to-blue-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                        <div className="relative">
                            {/* Payment Header */}
                            <div className="flex flex-col lg:flex-row lg:items-center justify-between mb-8 gap-6">
                                <div className="flex items-center gap-4">
                                    {/* Currency Icon */}
                                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                                        {curDetails?.[0]?.image ? (
                                            <Images height={32} source={curDetails[0].image} alt="currency" />
                                        ) : (
                                            <AiOutlineWallet className="text-white" size={24} />
                                        )}
                                    </div>

                                    <div>
                                        <h2 className="text-2xl font-bold text-white mb-2">Deposit Request</h2>
                                        <div className="flex items-center gap-2">
                                            <AiOutlineCopy className="text-gray-400" size={14} />
                                            <span className="text-gray-300 text-sm font-mono break-all">{getPendingPayment?.[0]?.txn_id}</span>
                                            <CopyToClipboard text={getPendingPayment?.[0]?.txn_id} onCopy={() => notify('Transaction ID copied!', 1)}>
                                                <button className="text-gray-400 hover:text-white transition-colors p-1 rounded hover:bg-white/10">
                                                    <AiOutlineCopy size={12} />
                                                </button>
                                            </CopyToClipboard>
                                        </div>
                                    </div>
                                </div>

                                {/* Status Badge */}
                                <div className={`px-4 py-3 rounded-2xl ${currentStatus.bgColor} border ${currentStatus.borderColor} flex items-center gap-3 shadow-lg`}>
                                    <currentStatus.icon className={currentStatus.color} size={20} />
                                    <span className={`text-lg font-semibold ${currentStatus.color}`}>
                                        {currentStatus.label}
                                    </span>
                                </div>
                            </div>

                            {/* Amount Display */}
                            <div className="bg-white/5 rounded-2xl p-6 border border-white/10 mb-8">
                                <div className="flex items-center gap-2 mb-3">
                                    <RiCurrencyLine className="text-blue-400" size={18} />
                                    <span className="text-gray-300 text-sm font-medium">Amount to Pay</span>
                                    <CopyToClipboard text={getPendingPayment?.[0]?.amountEnforcedToPay} onCopy={() => notify('Amount copied!', 1)}>
                                        <button className="text-gray-400 hover:text-white transition-colors p-1 rounded hover:bg-white/10 ml-auto">
                                            <AiOutlineCopy size={14} />
                                        </button>
                                    </CopyToClipboard>
                                </div>
                                <p className="text-white font-bold text-3xl">
                                    {displayableAmount}
                                </p>
                            </div>

                            {/* QR Code Section */}
                            {getPendingPayment?.[0]?.qrCode && (
                                <div className="flex justify-center mb-8">
                                    <div className="relative">
                                        <div className="bg-white/10 rounded-3xl p-6 border border-white/20 backdrop-blur-xl">
                                            <Images
                                                height={'250px'}
                                                width={'250px'}
                                                style={{ borderRadius: 'var(--radius-xl)' }}
                                                alt="Payment QR Code"
                                                src={getPendingPayment?.[0]?.qrCode}
                                            />
                                        </div>
                                        <div className="absolute -top-2 -right-2 w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg">
                                            <AiOutlineWallet className="text-white" size={20} />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Payment Details */}

                            <div className="space-y-6 mb-8">
                                {getPendingPayment?.[0]?.autoConfirm == 1 && (<div className="bg-white/5 rounded-2xl p-6 border border-white/10">
                                    <div className="flex items-center gap-3 mb-4">
                                        <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center">
                                            <RiCurrencyLine className="text-white" size={18} />
                                        </div>
                                        <h3 className="text-xl font-bold text-white">Crypto Payment Details</h3>
                                    </div>

                                    <div className="space-y-4">
                                        <div>
                                            <div className="text-gray-300 text-sm font-medium mb-2">Deposit Address</div>
                                            <div className="flex items-center gap-3 p-4 bg-white/5 rounded-xl border border-white/10">
                                                <span className="text-white font-mono text-sm break-all flex-1">{getPendingPayment?.[0]?.address}</span>
                                                <CopyToClipboard text={getPendingPayment?.[0]?.address} onCopy={() => notify('Address copied!', 1)}>
                                                    <button className="px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl text-white font-medium hover:from-blue-600 hover:to-purple-700 transition-all duration-300 flex items-center gap-2">
                                                        <AiOutlineCopy size={14} />
                                                        Copy
                                                    </button>
                                                </CopyToClipboard>
                                            </div>
                                        </div>

                                        <div className="bg-blue-500/10 border border-blue-400/20 rounded-xl p-4">
                                            <p className="text-blue-200 text-sm">
                                                Deposit exactly <strong className="text-white">{displayableAmount}</strong> to this address
                                            </p>
                                        </div>

                                        {getPendingPayment?.[0]?.paymentMessage && (
                                            <div className="bg-red-500/10 border border-red-400/20 rounded-xl p-4">
                                                <span className="text-red-200 text-sm">{getPendingPayment?.[0]?.paymentMessage}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>)}

                                {/* Countdown Timer */}
                                {(getPendingPayment?.[0]?.creationCryptoMerchant == 3 || getPendingPayment?.[0]?.timeout != '') && (
                                    <div className="bg-white/5 rounded-2xl p-6 border border-white/10">
                                        <div className="text-center">
                                            <div className="text-gray-300 text-sm font-medium mb-4">Payment Expires In</div>
                                            <div className="flex justify-center">
                                                <Countdown
                                                    date={new Date(getPendingPayment?.[0]?.timeout)}
                                                    renderer={({ hours, minutes, seconds, completed }) => {
                                                        if (completed) {
                                                            return (
                                                                <div className="bg-red-500/20 border border-red-400/30 rounded-2xl px-6 py-4">
                                                                    <span className="text-red-400 font-bold text-lg">Payment Expired</span>
                                                                </div>
                                                            )
                                                        } else {
                                                            return (
                                                                <div className="flex items-center gap-4 bg-white/10 rounded-2xl px-6 py-4">
                                                                    <div className="text-center">
                                                                        <div className="text-2xl font-bold text-white">{hours.toString().padStart(2, '0')}</div>
                                                                        <div className="text-xs text-gray-300">Hours</div>
                                                                    </div>
                                                                    <div className="text-white text-xl">:</div>
                                                                    <div className="text-center">
                                                                        <div className="text-2xl font-bold text-white">{minutes.toString().padStart(2, '0')}</div>
                                                                        <div className="text-xs text-gray-300">Min</div>
                                                                    </div>
                                                                    <div className="text-white text-xl">:</div>
                                                                    <div className="text-center">
                                                                        <div className="text-2xl font-bold text-white">{seconds.toString().padStart(2, '0')}</div>
                                                                        <div className="text-xs text-gray-300">Sec</div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Pay Now Button */}
                                {getPendingPayment?.[0]?.createdWithAutoOrManual == 0 && getPendingPayment?.[0]?.autoConfirm == 2 && (
                                    <div className="text-center">
                                        <form action={perfectWalletobj?.form_url} method="POST">
                                            {eachParam.map((eachkey, index) => (
                                                <input key={index} name={eachkey} value={perfectWalletobj.param[eachkey]} type="hidden" />
                                            ))}
                                            <button type="submit" className="px-8 py-4 bg-gradient-to-r from-green-500 to-blue-600 rounded-2xl text-white font-semibold hover:from-green-600 hover:to-blue-700 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-green-500/25 flex items-center gap-3 mx-auto">
                                                <AiOutlineWallet size={20} />
                                                Pay Now
                                            </button>
                                        </form>
                                    </div>
                                )}

                                {/* Upload Section */}
                                {getPendingPayment?.[0]?.createdWithAutoOrManual == 1 && (
                                    <div className="bg-white/5 rounded-2xl p-6 border border-white/10 text-center">
                                        <div className="flex items-center justify-center gap-3 mb-4">
                                            <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-blue-600 rounded-xl flex items-center justify-center">
                                                <AiOutlineCloudUpload className="text-white" size={18} />
                                            </div>
                                            <span className="text-xl font-bold text-white">Payment Receipt</span>
                                        </div>
                                        <button
                                            onClick={() => progClickPaymentUpload()}
                                            className="px-8 py-4 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl text-white font-semibold hover:from-blue-600 hover:to-purple-700 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-blue-500/25 flex items-center gap-3 mx-auto"
                                        >
                                            <AiOutlineCloudUpload size={18} />
                                            {getPendingPayment?.[0]?.image == null ? 'Upload Receipt' : 'Re-upload Receipt'}
                                        </button>
                                        <input
                                            style={{ display: 'none' }}
                                            ref={uploadPayment}
                                            onChange={(e) => uploadSelectedPayment(e.target.files[0])}
                                            type="file"
                                            accept=".jpg, .gif, .png, .jpeg"
                                        />
                                    </div>
                                )}
                            </div>


                            {/* Bank Details */}
                            {getPendingPayment?.[0]?.autoConfirm == 0 && (
                                <div className="bg-white/5 rounded-2xl p-6 border border-white/10 mb-8">
                                    <div className="flex items-center gap-3 mb-6">
                                        <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-blue-600 rounded-xl flex items-center justify-center">
                                            <AiOutlineWallet className="text-white" size={18} />
                                        </div>
                                        <h3 className="text-xl font-bold text-white">Bank Transfer Details</h3>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="space-y-2">
                                            <span className="text-gray-300 text-sm font-medium">{curDetails?.[0]?.accountNameText}</span>
                                            <div className="bg-white/5 rounded-xl p-4 border border-white/10">
                                                <span className="text-white font-semibold">{curDetails?.[0]?.accountName}</span>
                                            </div>
                                        </div>
                                        <div className="space-y-2">
                                            <span className="text-gray-300 text-sm font-medium">{curDetails?.[0]?.accountNumberText}</span>
                                            <div className="flex items-center gap-3 bg-white/5 rounded-xl p-4 border border-white/10">
                                                <span className="text-white font-mono flex-1">{curDetails?.[0]?.accountNumber}</span>
                                                <CopyToClipboard text={curDetails?.[0]?.accountNumber} onCopy={() => notify('Account number copied!', 1)}>
                                                    <button className="text-gray-400 hover:text-white transition-colors p-1 rounded hover:bg-white/10">
                                                        <AiOutlineCopy size={14} />
                                                    </button>
                                                </CopyToClipboard>
                                            </div>
                                        </div>
                                        <div className="space-y-2 md:col-span-2">
                                            <span className="text-gray-300 text-sm font-medium">Bank</span>
                                            <div className="bg-white/5 rounded-xl p-4 border border-white/10">
                                                <span className="text-white font-semibold">{curDetails?.[0]?.bankName}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Action Buttons */}
                            <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-white/10">
                                <button
                                    onClick={() => window.confirm('Are you sure you want to delete this payment request?') && deleteInv(getPendingPayment?.[0]?.txn_id)}
                                    className="flex-1 py-4 px-6 bg-red-500/20 border border-red-400/30 rounded-2xl text-red-400 hover:bg-red-500/30 transition-all duration-300 font-medium hover:scale-105 flex items-center justify-center gap-2"
                                >
                                    <AiFillCloseCircle size={18} />
                                    Delete Payment
                                </button>
                            </div>
                        </div>

                        {/* Progress indicator */}
                        <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-500 to-blue-500 opacity-60"></div>
                    </div>
                </div>
            </div>
        )


    }





    const loadAllDeposit = () => {

        
        dispatch(depositActions.onLoadAllDeposits("deposit/load", response => {
            
        }))

    }



    useEffect(() => {
        loadAllDeposit()
    }, [])


    const CurrencySelector = () => {
        return (
            <div className="currency-selector-container">
                <div className="currency-selector-wrapper">
                    <div
                        className="currency-selector-trigger"
                        onClick={() => setShowCurrencySelector(!showCurrencySelector)}
                    >
                        <div className="currency-info">
                            <div className="currency-icon">
                                <RiCurrencyLine size={24} />
                            </div>
                            <div className="currency-details">
                                <span className="currency-name">{currencySelected?.name || 'Select Currency'}</span>
                                <span className="currency-code">{currencySelected?.abbr || ''}</span>
                            </div>
                        </div>
                        <div className="currency-arrow">
                            <RiArrowDownSLine
                                size={20}
                                className={`arrow-icon ${showCurrencySelector ? 'rotated' : ''}`}
                            />
                        </div>
                    </div>

                    {showCurrencySelector && (
                        <div className="currency-dropdown">
                            <div className="currency-dropdown-header">
                                <span>Select Currency</span>
                                <button
                                    className="close-btn"
                                    onClick={() => setShowCurrencySelector(false)}
                                >
                                    ×
                                </button>
                            </div>
                            <div className="currency-list">
                                {finance?.map((currency, index) => (
                                    <div
                                        key={currency.type || index}
                                        className={`currency-option ${currencySelected?.type === currency.type ? 'selected' : ''}`}
                                        onClick={() => {
                                            setCurrencySelected(currency);
                                            setShowCurrencySelector(false);
                                        }}
                                    >
                                        <div className="currency-option-info">
                                            <div className="currency-option-icon">
                                                <RiCurrencyLine size={20} />
                                            </div>
                                            <div className="currency-option-details">
                                                <span className="currency-option-name">{currency.name}</span>
                                                <span className="currency-option-code">{currency.abbr}</span>
                                            </div>
                                        </div>
                                        <div className="currency-option-symbol">
                                            {currency.symbol}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                <style jsx>{`
                    .amount-input-wrapper {
                        position: relative;
                        display: flex;
                        align-items: center;
                    }

                    .currency-symbol-prefix {
                        position: absolute;
                        left: 15px;
                        font-size: var(--text-lg);
                        font-weight: var(--font-semibold);
                        color: var(--neutral-600);
                        z-index: 1;
                        pointer-events: none;
                    }

                    .amount-input {
                        padding-left: ${currencySelected?.symbol ? '45px' : '15px'} !important;
                    }
                    .currency-selector-container {
                        position: relative;
                        width: 100%;
                        margin-bottom: var(--space-4);
                    }

                    .currency-selector-wrapper {
                        position: relative;
                    }

                    .currency-selector-trigger {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: var(--space-4);
                        background: rgba(255, 255, 255, 0.1);
                        backdrop-filter: blur(10px);
                        -webkit-backdrop-filter: blur(10px);
                        border: 1px solid rgba(255, 255, 255, 0.2);
                        border-radius: var(--radius-lg);
                        cursor: pointer;
                        transition: all var(--transition-base);
                        min-height: 60px;
                    }

                    .currency-selector-trigger:hover {
                        background: rgba(255, 255, 255, 0.15);
                        border-color: rgba(255, 255, 255, 0.3);
                    }

                    .currency-info {
                        display: flex;
                        align-items: center;
                        gap: var(--space-3);
                    }

                    .currency-icon {
                        width: 40px;
                        height: 40px;
                        background: var(--gradient-primary);
                        border-radius: var(--radius-lg);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: white;
                        box-shadow: var(--shadow-md);
                    }

                    .currency-details {
                        display: flex;
                        flex-direction: column;
                        gap: 2px;
                    }

                    .currency-name {
                        font-size: var(--text-base);
                        font-weight: var(--font-medium);
                        color: white;
                        line-height: 1.2;
                    }

                    .currency-code {
                        font-size: var(--text-sm);
                        color: rgba(255, 255, 255, 0.7);
                        font-weight: var(--font-normal);
                    }

                    .currency-arrow {
                        color: rgba(255, 255, 255, 0.7);
                        transition: transform var(--transition-base);
                    }

                    .arrow-icon {
                        transition: transform var(--transition-base);
                    }

                    .arrow-icon.rotated {
                        transform: rotate(180deg);
                    }

                    .currency-dropdown {
                        position: absolute;
                        top: 100%;
                        left: 0;
                        right: 0;
                        background: rgba(255, 255, 255, 0.95);
                        backdrop-filter: blur(20px);
                        -webkit-backdrop-filter: blur(20px);
                        border: 1px solid rgba(255, 255, 255, 0.3);
                        border-radius: var(--radius-lg);
                        box-shadow: var(--shadow-xl);
                        z-index: 1000;
                        margin-top: var(--space-2);
                        max-height: 300px;
                        overflow-y: auto;
                        animation: slideDown 0.3s ease-out;
                    }

                    @keyframes slideDown {
                        from {
                            opacity: 0;
                            transform: translateY(-10px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    .currency-dropdown-header {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: var(--space-4);
                        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                        background: rgba(255, 255, 255, 0.8);
                        border-radius: var(--radius-lg) var(--radius-lg) 0 0;
                    }

                    .currency-dropdown-header span {
                        font-size: var(--text-sm);
                        font-weight: var(--font-semibold);
                        color: var(--neutral-700);
                    }

                    .close-btn {
                        background: none;
                        border: none;
                        font-size: var(--text-xl);
                        color: var(--neutral-500);
                        cursor: pointer;
                        padding: 0;
                        width: 24px;
                        height: 24px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: var(--radius-sm);
                        transition: all var(--transition-base);
                    }

                    .close-btn:hover {
                        background: rgba(0, 0, 0, 0.1);
                        color: var(--neutral-700);
                    }

                    .currency-list {
                        padding: var(--space-2);
                    }

                    .currency-option {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: var(--space-3);
                        border-radius: var(--radius-md);
                        cursor: pointer;
                        transition: all var(--transition-base);
                        margin-bottom: var(--space-1);
                    }

                    .currency-option:hover {
                        background: rgba(0, 0, 0, 0.05);
                    }

                    .currency-option.selected {
                        background: var(--primary-50);
                        border: 1px solid var(--primary-200);
                    }

                    .currency-option-info {
                        display: flex;
                        align-items: center;
                        gap: var(--space-3);
                    }

                    .currency-option-icon {
                        width: 32px;
                        height: 32px;
                        background: var(--primary-100);
                        border-radius: var(--radius-md);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: var(--primary-600);
                    }

                    .currency-option-details {
                        display: flex;
                        flex-direction: column;
                        gap: 2px;
                    }

                    .currency-option-name {
                        font-size: var(--text-sm);
                        font-weight: var(--font-medium);
                        color: var(--neutral-800);
                        line-height: 1.2;
                    }

                    .currency-option-code {
                        font-size: var(--text-xs);
                        color: var(--neutral-500);
                        font-weight: var(--font-normal);
                    }

                    .currency-option-symbol {
                        font-size: var(--text-sm);
                        font-weight: var(--font-semibold);
                        color: var(--neutral-700);
                    }

                    /* Mobile Responsive */
                    @media (max-width: 640px) {
                        .currency-selector-trigger {
                            padding: var(--space-3);
                            min-height: 56px;
                        }

                        .currency-icon {
                            width: 36px;
                            height: 36px;
                        }

                        .currency-name {
                            font-size: var(--text-sm);
                        }

                        .currency-dropdown {
                            max-height: 250px;
                        }

                        .currency-option {
                            padding: var(--space-2);
                        }

                        .currency-option-icon {
                            width: 28px;
                            height: 28px;
                        }
                    }

                    /* Dark mode support */
                    @media (prefers-color-scheme: dark) {
                        .currency-dropdown {
                            background: rgba(39, 39, 42, 0.95);
                            border-color: rgba(255, 255, 255, 0.2);
                        }

                        .currency-dropdown-header {
                            background: rgba(39, 39, 42, 0.8);
                            border-bottom-color: rgba(255, 255, 255, 0.1);
                        }

                        .currency-dropdown-header span {
                            color: var(--dark-700);
                        }

                        .currency-option:hover {
                            background: rgba(255, 255, 255, 0.05);
                        }

                        .currency-option.selected {
                            background: rgba(14, 165, 233, 0.1);
                            border-color: rgba(14, 165, 233, 0.3);
                        }

                        .currency-option-name {
                            color: var(--dark-800);
                        }

                        .currency-option-code {
                            color: var(--dark-500);
                        }

                        .currency-option-symbol {
                            color: var(--dark-700);
                        }
                    }
                `}</style>
            </div>
        );
    };

    const newPayment = () => {

        return <FullScreenInputHolder>
            <div className="modern-deposit-container min-h-screen p-4">
                <div className="max-w-4xl mx-auto pt-8">
                    <div className="text-center mb-12">
                        <h1 className="text-4xl font-bold text-white mb-4 bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
                            Fund Wallet
                        </h1>
                        <p className="text-xl text-blue-200">
                            Secure and fast deposits
                        </p>
                    </div>

                    <div className="deposit-card glass-card animate-fade-in-up">
                    <div className="deposit-header">
                        <div className="deposit-icon">
                            <AiOutlineWallet size={32} />
                        </div>
                        <div className="deposit-title-section">
                            <h2 className="deposit-title">Fund Wallet</h2>
                            <p className="deposit-subtitle">Add funds to your account securely</p>
                        </div>
                    </div>

                    <form onSubmit={processDeposit} className="deposit-form">

                        {/* Currency Selector */}
                        <div className="form-group">
                            <label className="form-label">
                                <span className="label-icon">
                                    <RiCurrencyLine size={18} />
                                </span>
                                Select Currency
                            </label>
                            <CurrencySelector />
                        </div>

                        {/* Amount Input */}
                        <div className="form-group">
                            <label className="form-label">
                                <span className="label-icon">
                                    <AiOutlineWallet size={18} />
                                </span>
                                Deposit Amount
                            </label>
                            <div className="amount-input-container">
                                {currencySelected?.symbol && (
                                    <span className="currency-symbol-prefix">{currencySelected.symbol}</span>
                                )}
                                <input
                                    type="text"
                                    className="modern-amount-input"
                                    onChange={(e) => setAmount(e.target.value)}
                                    value={amount}
                                    placeholder={`Enter amount in ${currencySelected?.abbr || 'selected currency'}`}
                                />
                                <div className="input-focus-indicator"></div>
                            </div>
                        </div>


                        {/* Submit Button */}
                        <div className="form-actions">
                            <button
                                type="submit"
                                disabled={loading || !currencySelected}
                                className={`submit-btn ${loading ? 'loading' : ''} ${!currencySelected ? 'disabled' : ''}`}
                            >
                                {loading ? (
                                    <>
                                        <div className="btn-spinner"></div>
                                        Processing...
                                    </>
                                ) : (
                                    <>
                                        <AiOutlineCloudUpload size={20} />
                                        Submit Deposit
                                    </>
                                )}
                            </button>
                        </div>

                    </form>
                </div>
                </div>
            </div>

            <style jsx>{`
                .modern-deposit-container {
                    max-width: 600px;
                    margin: 0 auto;
                    padding: var(--space-6);
                }

                .deposit-card {
                    background: rgba(255, 255, 255, 0.1);
                    backdrop-filter: blur(20px);
                    -webkit-backdrop-filter: blur(20px);
                    border: 1px solid rgba(255, 255, 255, 0.2);
                    border-radius: var(--radius-3xl);
                    padding: var(--space-8);
                    box-shadow: var(--shadow-xl);
                    position: relative;
                    overflow: hidden;
                }

                .deposit-card::before {
                    content: '';
                    position: absolute;
                    top: -50%;
                    left: -50%;
                    width: 200%;
                    height: 200%;
                    background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
                    transform: rotate(45deg);
                    animation: shimmer 3s infinite;
                }

                .deposit-header {
                    display: flex;
                    align-items: center;
                    gap: var(--space-4);
                    margin-bottom: var(--space-8);
                    position: relative;
                    z-index: 1;
                }

                .deposit-icon {
                    width: 64px;
                    height: 64px;
                    background: var(--gradient-primary);
                    border-radius: var(--radius-2xl);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    box-shadow: var(--shadow-lg);
                    position: relative;
                    z-index: 1;
                }

                .deposit-title-section {
                    flex: 1;
                }

                .deposit-title {
                    font-size: var(--text-2xl);
                    font-weight: var(--font-bold);
                    color: white;
                    margin: 0 0 var(--space-1) 0;
                    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                }

                .deposit-subtitle {
                    font-size: var(--text-base);
                    color: rgba(255, 255, 255, 0.7);
                    margin: 0;
                    font-weight: var(--font-normal);
                }

                .deposit-form {
                    position: relative;
                    z-index: 1;
                }

                .form-group {
                    margin-bottom: var(--space-6);
                }

                .form-label {
                    display: flex;
                    align-items: center;
                    gap: var(--space-2);
                    font-size: var(--text-sm);
                    font-weight: var(--font-semibold);
                    color: white;
                    margin-bottom: var(--space-3);
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .label-icon {
                    width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: var(--radius-md);
                    color: rgba(255, 255, 255, 0.8);
                }

                .amount-input-container {
                    position: relative;
                    display: flex;
                    align-items: center;
                }

                .currency-symbol-prefix {
                    position: absolute;
                    left: var(--space-4);
                    font-size: var(--text-lg);
                    font-weight: var(--font-semibold);
                    color: var(--primary-600);
                    z-index: 2;
                    pointer-events: none;
                }

                .modern-amount-input {
                    width: 100%;
                    height: 64px;
                    padding: var(--space-4) var(--space-4);
                    padding-left: ${currencySelected?.symbol ? '60px' : 'var(--space-4)'};
                    font-size: var(--text-lg);
                    font-weight: var(--font-bold);
                    color: var(--neutral-900);
                    background: #ffffff;
                    backdrop-filter: blur(10px);
                    -webkit-backdrop-filter: blur(10px);
                    border: 2px solid rgba(14, 165, 233, 0.35);
                    border-radius: var(--radius-xl);
                    outline: none;
                    transition: all var(--transition-base);
                    box-shadow: 0 8px 24px rgba(2, 6, 23, 0.08);
                }

                .modern-amount-input:focus {
                    border-color: var(--primary-500);
                    box-shadow: 0 0 0 4px rgba(14, 165, 233, 0.15), var(--shadow-lg);
                    background: #ffffff;
                    transform: translateY(-1px);
                }

                .modern-amount-input::placeholder {
                    color: var(--neutral-500);
                    font-weight: var(--font-medium);
                }

                .input-focus-indicator {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 2px;
                    background: var(--gradient-primary);
                    border-radius: var(--radius-sm);
                    transform: scaleX(0);
                    transition: transform var(--transition-base);
                }

                .modern-amount-input:focus + .input-focus-indicator {
                    transform: scaleX(1);
                }

                .currency-info-card {
                    background: rgba(14, 165, 233, 0.1);
                    border: 1px solid rgba(14, 165, 233, 0.2);
                    border-radius: var(--radius-xl);
                    padding: var(--space-5);
                    display: flex;
                    align-items: flex-start;
                    gap: var(--space-4);
                    margin-bottom: var(--space-6);
                    backdrop-filter: blur(10px);
                    -webkit-backdrop-filter: blur(10px);
                }

                .info-icon {
                    width: 40px;
                    height: 40px;
                    background: var(--primary-500);
                    border-radius: var(--radius-lg);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    flex-shrink: 0;
                    box-shadow: var(--shadow-md);
                }

                .info-content {
                    flex: 1;
                }

                .info-title {
                    font-size: var(--text-base);
                    font-weight: var(--font-semibold);
                    color: white;
                    margin: 0 0 var(--space-2) 0;
                }

                .info-description {
                    font-size: var(--text-sm);
                    color: rgba(255, 255, 255, 0.8);
                    margin: 0;
                    line-height: var(--leading-relaxed);
                }

                .form-actions {
                    margin-top: var(--space-8);
                }

                .submit-btn {
                    width: 100%;
                    height: 64px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: var(--space-3);
                    font-size: var(--text-lg);
                    font-weight: var(--font-semibold);
                    color: white;
                    background: var(--gradient-primary);
                    border: none;
                    border-radius: var(--radius-xl);
                    cursor: pointer;
                    transition: all var(--transition-base);
                    box-shadow: var(--shadow-lg);
                    position: relative;
                    overflow: hidden;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .submit-btn::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                    transition: left var(--transition-base);
                }

                .submit-btn:hover::before {
                    left: 100%;
                }

                .submit-btn:hover:not(:disabled) {
                    transform: translateY(-2px);
                    box-shadow: var(--shadow-xl);
                    background: linear-gradient(135deg, var(--primary-400) 0%, var(--primary-600) 100%);
                }

                .submit-btn:active:not(:disabled) {
                    transform: translateY(0);
                    box-shadow: var(--shadow-md);
                }

                .submit-btn.disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                    background: var(--neutral-400);
                }

                .submit-btn.loading {
                    cursor: not-allowed;
                }

                .btn-spinner {
                    width: 20px;
                    height: 20px;
                    border: 2px solid rgba(255, 255, 255, 0.3);
                    border-top: 2px solid white;
                    border-radius: var(--radius-full);
                    animation: spin 1s linear infinite;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                @keyframes shimmer {
                    0% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
                    100% { transform: translateX(100%) translateY(100%) rotate(45deg); }
                }

                /* Mobile Responsive */
                @media (max-width: 768px) {
                    .modern-deposit-container {
                        padding: var(--space-4);
                    }

                    .deposit-card {
                        padding: var(--space-6);
                        border-radius: var(--radius-2xl);
                    }

                    .deposit-header {
                        flex-direction: column;
                        text-align: center;
                        gap: var(--space-3);
                    }

                    .deposit-icon {
                        width: 56px;
                        height: 56px;
                    }

                    .deposit-title {
                        font-size: var(--text-xl);
                    }

                    .modern-amount-input {
                        height: 56px;
                        font-size: var(--text-base);
                    }

                    .submit-btn {
                        height: 56px;
                        font-size: var(--text-base);
                    }

                    .currency-info-card {
                        padding: var(--space-4);
                        flex-direction: column;
                        text-align: center;
                    }

                    .info-icon {
                        align-self: center;
                    }
                }

                @media (max-width: 480px) {
                    .modern-deposit-container {
                        padding: var(--space-3);
                    }

                    .deposit-card {
                        padding: var(--space-4);
                    }

                    .deposit-icon {
                        width: 48px;
                        height: 48px;
                    }

                    .deposit-title {
                        font-size: var(--text-lg);
                    }

                    .modern-amount-input {
                        height: 48px;
                        padding: var(--space-3);
                        padding-left: ${currencySelected?.symbol ? '50px' : 'var(--space-3)'};
                    }

                    .submit-btn {
                        height: 48px;
                        font-size: var(--text-sm);
                    }
                }
            `}</style>
        </FullScreenInputHolder>

    }












    return (

        <SiteWide id="main" title={"Account Fund"}>
            <Section overlayText={loadingText} loading={loading} title={'Account Fund'} style={{}}>


                {(getPendingPayment?.length ?? 0) == 0 ? newPayment() : thePendingPayment()}

            </Section>

        </SiteWide>
    );
}

export default DepositHistory;


